import moment from 'moment/moment';
import BaseServiceCrud from './BaseServiceCrud';
import Constants from '../utils/constants';

export default class ProjectDailyOverviewService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'project-daily-overview';
    }
    getCriteria(criteria) {
        return this.objToQueryString(this.mapCriteriaToQuery(criteria));
    }
    
    exportList(criteria, format) {
        return super.exportList(this.objToQueryString(this.mapCriteriaToQuery(criteria, { export_type: format })));
    }
    
    mapCriteriaToQuery(criteria, additionalParams = {}) {
        return {
            project_name: criteria.projectName,
            country_name: criteria.countryName,
            status_level: criteria.statusLevel?.enumValue,
            start_date: criteria.startDate ? moment(criteria.startDate).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            end_date: criteria.endDate ? moment(criteria.endDate).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            ...additionalParams 
        };
    }
}
